import { AutocompleteFaqsStandalone } from '@/components/molecules/AutocompleteFaqs';
import LazySearchInit from '@/faq/LazySearch';
import { loadCarousels } from '@/utils/Controllers/CarouselController';
import { initAllSelects } from '@/utils/Controllers/EasyDropDownController';
import VideoController from '@/faq/VideoController';

document.addEventListener('DOMContentLoaded', () => {
  AutocompleteFaqsStandalone();
  LazySearchInit();
  VideoController();
  loadCarousels({ mobileOnly: true });
  initAllSelects({
    callbacks: {
      onOptionClick: value => {
        window.location = `${DLG.config.encodedContextPath}/faqs${value}`;
      },
    },
  });
});
